import slide1Image from "../../../assets/images/featureDiscovery/confirmLaunch/slide1.svg";
import slide2Image from "../../../assets/images/featureDiscovery/confirmLaunch/slide2.svg";
import slide3Image from "../../../assets/images/featureDiscovery/confirmLaunch/slide3.svg";
import slide4Image from "../../../assets/images/featureDiscovery/confirmLaunch/slide4.svg";
import { FeatureDiscoveryTour } from "../types";

export const confirmLaunchTour: FeatureDiscoveryTour = {
  featureKey: "confirm_launch",
  title: "Ordering Unity Confirm™",
  badgeLabel: "New",
  helpTitle: "Unity Confirm",
  slides: [
    {
      id: "availability",
      image: slide1Image,
      imageAlt: "Unity Confirm alert ordering workflow",
      body: (
        <>
          <p>
            <strong>Unity Confirm</strong>, our newest confirmation assay is now
            available for ordering!
          </p>
          <p>
            <strong>How it works:</strong> An alert automatically appears for
            eligible patients, displaying their details and blood draw timeline.
            Samples must be collected by{" "}
            <strong>15 weeks 6 days’ gestation</strong> and received by the lab{" "}
            <strong>within 6 days</strong> of the draw. Click the alert to order
            Unity Confirm and get started.
          </p>
        </>
      ),
    },
    {
      id: "dismissed-alert",
      image: slide2Image,
      imageAlt: "Unity Confirm eligible row highlighted in blue",
      body: (
        <>
          <p>
            If you dismiss the alert, the eligible patient&apos;s row will be
            highlighted in blue — you can still initiate the order directly from
            there.
          </p>
          <p>
            To reopen the alert at any time, click the Alerts button in the
            top-right corner.
          </p>
        </>
      ),
    },
    {
      id: "attestation",
      image: slide3Image,
      imageAlt: "Unity Confirm attestation before order submission",
      body: (
        <>
          <p>
            Unity Confirm is time-sensitive, and eligibility is based on
            specific criteria.
          </p>
          <p>
            Before submitting a test order, you will be asked to review and
            attest that these criteria are met to ensure accurate and timely
            results.
          </p>
        </>
      ),
    },
    {
      id: "results",
      image: slide4Image,
      imageAlt: "Unity Confirm results shown in the Aneuploidy column",
      body: (
        <>
          <p>
            Unity Confirm results will appear in blue within the Aneuploidy
            column on the Completed tab and will be labeled{" "}
            <strong>Unity Confirm</strong>.
          </p>
          <p>
            Click the blue arrow to open the report, which includes the Unity
            Confirm results along with the appended Unity Aneuploidy report.
          </p>
        </>
      ),
    },
  ],
};
